import React, { Component } from 'react'
import { connect } from 'react-redux'
import * as actions from '../../state/actions'
import { bindActionCreators } from 'redux'
import { Alert } from 'react-bootstrap'
import Spinner from './../common/Spinner'

class UserDetail extends Component {
    componentDidMount() {
        var self = this;
        self.props.actions.userGetOne(self.props.params.appCodename, self.props.params.userId);
    }

    render() {
        var self = this

        if (!self.props.user) {
            return (<Spinner/>)
        } else if (self.props.user && !self.props.user._id) {
            return (
                <Alert bsStyle="warning">
                    <strong>No se encontro al usuario!</strong>
                </Alert>
            )
        } else {
            var displayName = self.props.user.displayName
            var emailValue = self.props.user.emails[0].value
            var name = self.props.user.name && self.props.user.name.givenName || ''
            var surname = self.props.user.name && self.props.user.name.familyName || ''

            return (
                <div>
                    <div className="row">
                        <div className="col-lg-12">
                            <h1 className="page-header">{displayName}</h1>
                        </div>
                    </div>
                    <div className="row">
                        <div className="col-lg-12">
                            <p>Información del usuario</p>
                        </div>
                    </div>
                    <div className="row">
                        <div className="col-lg-12">
                            <table className="table table-bordered table-hover">
                                <tbody>
                                    <tr className="active">
                                        <td className="col-md-2">
                                            <b>Display Name</b>
                                        </td>
                                        <td className="col-md-10">{displayName}</td>
                                    </tr>
                                    <tr>
                                        <td className="col-md-2">
                                            <b>Email</b>
                                        </td>
                                        <td className="col-md-10">{emailValue}</td>
                                    </tr>
                                    <tr className="active">
                                        <td className="col-md-2">
                                            <b>Nombre</b>
                                        </td>
                                        <td className="col-md-10">{name}</td>
                                    </tr>
                                    <tr>
                                        <td className="col-md-2">
                                            <b>Apellido</b>
                                        </td>
                                        <td className="col-md-10">{surname}</td>
                                    </tr>
                                </tbody>
                            </table>
                        </div>
                    </div>
                </div>
            )
        }
    }
}

function mapStateToProps(state) {
    return {
        user: state.user
    }
}

function mapDispatchToProps(dispatch) {
    return {
        actions: bindActionCreators(actions, dispatch)
    }
}

export default connect(mapStateToProps, mapDispatchToProps, null, { withRef: true })(UserDetail)



// WEBPACK FOOTER //
// ./components/UserDetail/index.js